export default "__VITE_ASSET__55fbd2b6__"